import { Security } from "../proto/generated/security"


export enum SecurityClickSource {
    WATCHLIST = "WATCHLIST"
}

export type SecurityClickEventData = {
    key: string,
    securities: Security[],
    expressionMode: boolean,
    source: SecurityClickSource
}